<template>
    <div class="container-fluid" style="background: whitesmoke; min-height: 100vh; padding-left: 0; padding-right: 0;">
        <NavBar />
        <div class="jumbotron" style="margin-bottom: 0; background: #1d4354; box-shadow: 0 8px 6px -6px black; padding: 30px; margin-top: 50px">
            <div class="container align-self-center">
                <div class="row">
                    <div id="col-start" class="col-xs-6 col-md-4 align-self-center"></div>
                    <div id="col-info" class="col-xs-6 col-md-4" style="text-align: center">
                        <h3 class="display-5" style="color: whitesmoke">Sequence List</h3>
                        <small style="color: #b4bcc3">View/Edit a LyteSync Sequence</small>
                    </div>
                    <div id="col-end" class="col-xs-6 col-md-4 align-self-center"></div>
                </div>

            </div>
        </div>

        <div v-if=!firebaseData class="card horizontal" style="max-width:80%; padding: 20px; border: none; margin: 15px auto 0;">
            <p>Loading ... </p>
        </div>
        <div v-else class="card horizontal" style="max-width:80%; padding: 20px; border: none; margin: 15px auto 0;">
            <MasterDataList :id=getFbUserFromState.id :user-info=firebaseData.userInfo :master-data=firebaseData.masterData />
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import NavBar from "./NavBar.vue";
    import firebase from "firebase";
    const fb = require('../firebaseConfig.js');
    import MasterDataList from "./MasterDataList";

    export default {
        data() {
            return {
                user: null,
                firebaseData: null,
            };
        },
        computed: {
            ...mapGetters({
                getFbUserFromState: 'getFbUserFromState',
            })
        },
        components: {
            NavBar,
            MasterDataList
        },
        methods: {
            getCurrentUserFirebaseData(uid) {

                let userDocRef = fb.usersCollection.doc(uid);
                return userDocRef.get().then(user => {
                    console.log('fetch user firebase root info: ', user.data());

                    if (user.data()) {
                        let masterSubCollectionRef = userDocRef.collection('master').orderBy("seq_no", "desc").get();
                        masterSubCollectionRef.then(snapshot => {
                            let masterDataCollectionForUser = {};
                            snapshot.forEach(doc => {
                                masterDataCollectionForUser[doc.id] = doc.data();
                            });

                            const fbUserPayload = {
                                userInfo: user.data(),
                                masterData: masterDataCollectionForUser
                            };

                            this.$store.dispatch('setCurrentUserCollectionAction', fbUserPayload);
                            this.firebaseData = fbUserPayload;

                            return fbUserPayload;
                        }).catch(err => {
                            console.log(err)
                        });

                    } else {

                        //sometimes user data might not be populated from the trigger method,
                        //in that case wait for few seconds before tying again.
                        console.log('waiting few seconds before trying to fetch user data again ');
                        this.wait(5000);

                        fb.usersCollection.doc(uid).collection('master').get()
                            .then(snapshot => {
                                let masterDataCollectionForUser = {};
                                snapshot.forEach(doc => {
                                    masterDataCollectionForUser[doc.id] = doc.data();
                                });

                                const fbUserPayload = {
                                    userInfo: user.data(),
                                    masterData: masterDataCollectionForUser
                                };

                                this.$store.dispatch('setCurrentUserCollectionAction', fbUserPayload);
                                this.firebaseData = fbUserPayload;

                                return fbUserPayload;

                            }).catch(err => {
                                console.log(err)
                            });
                    }

                }).catch(err => {
                    console.log(err)
                })

            },
            wait(ms) {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve()
                    }, ms)
                })
            },
        },
        created() {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    this.getCurrentUserFirebaseData(user.uid).then(() => {
                        console.log('received firebase data for user')
                    }).catch(err => {
                        console.log(err)
                    });
                }
            });
        }
    };
</script>
